import FormGroup from '@material-ui/core/FormGroup';
import React from 'react';
import { AccountDetail } from '../../../__generated__/pge-types';
import AccountListItem from './AccountListItem';
import { MulticheckState } from '../../../hooks/useMulticheckState';
import useUpdateDefaultAccount from '../../../hooks/useUpdateDefaultAccount';
import Backdrop from '../../backdrop';
import { BillMenuType } from './useAccountListItemMenuItems';
import { NickNameAddressPayload } from '../../nickname-change-modal/types';

type Props = {
  groupId?: string;
  accounts: Array<AccountDetail>;
  manageAccounts?: boolean;
  hideMenu?: boolean;
  onViewDetails?: (account: AccountDetail) => void;
  multicheckState?: MulticheckState;
  inactiveText?: string;
  billMenuType?: BillMenuType;
  accountsListCacheUpdate?: (payload: NickNameAddressPayload) => void;
};

export default function AccountList(props: Props) {
  const {
    groupId,
    accounts,
    hideMenu,
    manageAccounts,
    multicheckState,
    inactiveText,
    onViewDetails,
    billMenuType = 'PAY',
    accountsListCacheUpdate,
  } = props;

  const { savingDefaultAccount } = useUpdateDefaultAccount();

  return (
    <>
      {savingDefaultAccount && <Backdrop forceOpen />}
      <FormGroup>
        {accounts.map((account: AccountDetail) => {
          return (
            <AccountListItem
              groupId={groupId}
              inactiveText={inactiveText}
              key={account.accountNumber}
              account={account}
              manageAccounts={Boolean(manageAccounts)}
              onCheckboxChange={
                multicheckState
                  ? multicheckState.handleCheckToggle(account.accountNumber)
                  : () => true
              }
              checked={
                multicheckState
                  ? multicheckState.isChecked(account.accountNumber)
                  : false
              }
              checkDisabled={
                multicheckState
                  ? !multicheckState.isAnOption(account.accountNumber)
                  : true
              }
              hideMenu={hideMenu}
              onViewDetails={onViewDetails}
              billMenuType={billMenuType}
              accountsListCacheUpdate={accountsListCacheUpdate}
            />
          );
        })}
      </FormGroup>
    </>
  );
}
